import { render, staticRenderFns } from "./CommonHead.vue?vue&type=template&id=377b443a&scoped=true&"
import script from "./CommonHead.vue?vue&type=script&lang=js&"
export * from "./CommonHead.vue?vue&type=script&lang=js&"
import style0 from "./CommonHead.vue?vue&type=style&index=0&id=377b443a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b443a",
  null
  
)

export default component.exports